import React, { useEffect, useState } from 'react';
import { CircularProgress, Box, LinearProgress, Slide } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { observer } from 'mobx-lite';
import { FaceSdkStoreContextItem } from '../Stores/FaceSdkStore';
import { GlassNotification } from './GlassNotification';
import { accentColors } from './glassStyles';

export const LoadingFeedback: React.FC = observer(() => {
    const faceSdkStore = FaceSdkStoreContextItem.useStore();
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (faceSdkStore.faceSdk && !faceSdkStore.sdkInitializing && !faceSdkStore.error) {
            setShowSuccess(true);
            const timer = setTimeout(() => setShowSuccess(false), 2000);
            return () => clearTimeout(timer);
        }
        setShowSuccess(false);
    }, [faceSdkStore.faceSdk, faceSdkStore.sdkInitializing, faceSdkStore.error]);

    if (faceSdkStore.faceSdk && !faceSdkStore.sdkInitializing && !faceSdkStore.error && !showSuccess) {
        return null;
    }

    const mounted = faceSdkStore.sdkInitializing || !!faceSdkStore.error || showSuccess;

    return (
        <Box sx={{ position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 1000 }}>
            <Slide direction="down" in={mounted} mountOnEnter unmountOnExit>
                <div>
                    {faceSdkStore.sdkInitializing && (
                        <GlassNotification
                            accent={accentColors.info}
                            icon={<CircularProgress size={16} sx={{ color: accentColors.info }} />}
                            title="Initializing Models"
                            subtitle="Loading face recognition models…"
                        >
                            <LinearProgress
                                sx={{
                                    mt: 0.75,
                                    height: 3,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(255,255,255,0.1)',
                                    '& .MuiLinearProgress-bar': { borderRadius: 2, bgcolor: accentColors.info },
                                }}
                            />
                        </GlassNotification>
                    )}

                    {faceSdkStore.error && (
                        <GlassNotification
                            accent={accentColors.error}
                            icon={<Close sx={{ fontSize: 18 }} />}
                            title="Initialization Error"
                            subtitle={faceSdkStore.error}
                        />
                    )}

                    {showSuccess && !faceSdkStore.sdkInitializing && !faceSdkStore.error && (
                        <GlassNotification
                            accent={accentColors.success}
                            icon={<Check sx={{ fontSize: 18 }} />}
                            title="Models Ready"
                            subtitle="Face recognition initialized successfully"
                        />
                    )}
                </div>
            </Slide>
        </Box>
    );
});
